import { render, staticRenderFns } from "./RegisterResult.vue?vue&type=template&id=73db71f4&scoped=true"
import script from "./RegisterResult.vue?vue&type=script&lang=js"
export * from "./RegisterResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73db71f4",
  null
  
)

export default component.exports